export default "__VITE_ASSET__Cp04QCZG__"